// classnames which are used for direct DOM querying during PDF generation

export const PAGE_WRAPPER_TITLE_CLASSNAME = 'pageWrapperTitle'
export const SECTION_HEADER_CONTAINER_CLASSNAME = 'sectionHeaderContainer'
export const TABLE_CLASSNAME = 'table'
export const TABLE_ROW_CLASSNAME = 'row'
export const TABLE_COL_CLASSNAME = 'col'
